// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"style_fieldset__89B6r"};